<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <IconRow icon="mdi-account">
      <template #content>
        <v-col>
          <VTextField
            v-model="data.firstName"
            :label="$t('forms.labels.firstName')"
            :rules="{ required: true, min: 1, max: 200 }"
            :disabled="!isEditable"
            data-cy="profileForm-firstName"
            @input="updateData"
          />
        </v-col>
        <v-col>
          <VTextField
            v-model="data.lastName"
            :label="$t('forms.labels.lastName')"
            :rules="{ required: true, min: 1, max: 200 }"
            :disabled="!isEditable"
            data-cy="profileForm-lastName"

            @input="updateData"
          />
        </v-col>
      </template>
    </IconRow>

    <IconRow icon="mdi-email">
      <template #content>
        <v-col>
          <VTextField
            v-model="data.email"
            :label="$t('forms.labels.email')"
            :disabled="true"
            data-cy="profileForm-email"
          />
        </v-col>
        <v-col>
          <VSelect
            v-model="data.lang"
            :label="$t('forms.labels.emailLang')"
            :items="langs"
            itemValue="key"
            :disabled="!isEditable"
            data-cy="profileForm-lang"

            @input="updateData"
          />
        </v-col>
      </template>
    </IconRow>
    <IconRow icon="mdi-phone">
      <template #content>
        <v-col>
          <PhoneNumberInput
            :refObserver="$refs.observer"
            :value="data.phoneNumber.number"
            :disabled="!isEditable"
            :isPhoneNumberValid="data.isPhoneNumberValid"
            data-cy="profileForm-phone"

            @inputChanged="phoneInput"
          />
        </v-col>
      </template>
    </IconRow>

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import IconRow from '@/components/shared/containers/IconRow.vue';
import PhoneNumberInput from '@/components/shared/widgets/forms/PhoneNumberInput.vue';

export default {
    components: {
        IconRow,
        SlotScopeWatcher,
        VSelect,
        VTextField,
        ValidationObserver,
        PhoneNumberInput,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    props: {
        langs: {
            type: Array,
            default: () => [],
        },
        isEditable: {
            type: Boolean,
            default: false,
        },
        populateWith: {
            type: Object,
            default: () => ({ empty: true }),
        },
    },
    data() {
        return {
            data: {
                firstName: null,
                lastName: null,
                email: null,
                phoneNumber: { number: '' },
                lang: null,
            },
        };
    },
    watch: {
        populateWith: {
            handler() {
                if (!this.populateWith.empty) {
                    this.data = this.populateWith;
                    this.data.phoneNumber = this.populateWith.phoneNumber ? this.populateWith.phoneNumber : { number: '' };
                }
            },
            immediate: true,
        },
    },

    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
        phoneInput(number, payload) {
            this.data.phoneNumber = !number ? {} : payload;
            this.updateData();
        },
    },
};
</script>
